import React from 'react'
import '../../css/Main/TopCategories.css'
import background from '../../Assets/background.jpg'
import { useNavigate } from 'react-router-dom';
const TopCategoryCard = ({category}) => {
  const navigate = useNavigate();
  return (
    <div className='top-category-card' onClick={() => navigate(`/termekek/${category.name}`)}>
        <img src={background} alt='logo'/>
        <h2>{category.name}</h2>
    </div>
  )
}

export default TopCategoryCard